const pageNameKey = "otaConfirmFirmwareInstallationModal";

export const otaConfirmFirmwareInstallationModalEn = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Close confirm firmware installation modal",
    closeModalAriaLabelBackup: "Close confirm backup installation modal",
    titleFirmware: "Confirm Firmware Installation",
    titleBackup: "Confirm Backup Installation",
    firmwareSectionTitle: "The firmware",
    backupSectionTitle: "The backup",
    uploadedAtLabel: "uploaded",
    machineSectionTitle: "will be pushed to the machine",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    targetPathLabel: "Target path on the machine",
    firmwareFoldersSectionTitle:
      "The firmware package contains the following folders:",
    backupFoldersSectionTitle:
      "The backup package contains the following folders:",
    warningTextFirmware:
      "Do you want to overwrite the folders and files on the machine in the target folder? Please ensure that the machine is in maintenance mode. The firmware installation will be executed after your confirmation.",
    warningTextBackup:
      "Do you want to overwrite the folders and files on the machine in the target folder? Please ensure that the machine is in maintenance mode. The backup installation will be executed after your confirmation.",
    denyButtonText: "Deny",
    approveButtonText: "Approve",
    denySuccessMessage: "Installation process denied successfully.",
    denyFailureMessage: "Failed to deny the installation process",
    denyErrorMessageFirmware: "Error denying the firmware installation",
    denyErrorMessageBackup: "Error denying the backup installation",
    approveSuccessMessage: "Installation process approved successfully.",
    approveFailureMessage: "Failed to approve the installation process",
    approveErrorMessageFirmware: "Error approving the firmware installation",
    approveErrorMessageBackup: "Error approving the backup installation",
  },
};

export const otaConfirmFirmwareInstallationModalPtBr = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Fechar modal de confirmação de instalação de firmware",
    closeModalAriaLabelBackup:
      "Fechar modal de confirmação de instalação de backup",
    titleFirmware: "Confirmar Instalação de Firmware",
    titleBackup: "Confirmar Instalação de Backup",
    firmwareSectionTitle: "O firmware",
    backupSectionTitle: "O backup",
    uploadedAtLabel: "enviado em",
    machineSectionTitle: "será enviado para a máquina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    targetPathLabel: "Caminho de destino na máquina",
    firmwareFoldersSectionTitle:
      "O pacote de firmware contém as seguintes pastas:",
    backupFoldersSectionTitle: "O pacote de backup contém as seguintes pastas:",
    warningTextFirmware:
      "Deseja sobrescrever as pastas e arquivos na máquina na pasta de destino? Certifique-se de que a máquina está em modo de manutenção. A instalação do firmware será executada após sua confirmação.",
    warningTextBackup:
      "Deseja sobrescrever as pastas e arquivos na máquina na pasta de destino? Certifique-se de que a máquina está em modo de manutenção. A instalação do backup será executada após sua confirmação.",
    denyButtonText: "Negar",
    approveButtonText: "Aprovar",
    denySuccessMessage: "Processo de instalação negado com sucesso.",
    denyFailureMessage: "Falha ao negar o processo de instalação",
    denyErrorMessageFirmware: "Erro ao negar a instalação do firmware",
    denyErrorMessageBackup: "Erro ao negar a instalação do backup",
    approveSuccessMessage: "Processo de instalação aprovado com sucesso.",
    approveFailureMessage: "Falha ao aprovar o processo de instalação",
    approveErrorMessageFirmware: "Erro ao aprovar a instalação do firmware",
    approveErrorMessageBackup: "Erro ao aprovar a instalação do backup",
  },
};

export const otaConfirmFirmwareInstallationModalDe = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Modal zur Firmware-Installationsbestätigung schließen",
    closeModalAriaLabelBackup:
      "Modal zur Backup-Installationsbestätigung schließen",
    titleFirmware: "Firmware-Installation bestätigen",
    titleBackup: "Backup-Installation bestätigen",
    firmwareSectionTitle: "Die Firmware",
    backupSectionTitle: "Das Backup",
    uploadedAtLabel: "hochgeladen",
    machineSectionTitle: "wird auf die Maschine übertragen",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    targetPathLabel: "Zielpfad auf der Maschine",
    firmwareFoldersSectionTitle: "Das Firmware-Paket enthält folgende Ordner:",
    backupFoldersSectionTitle: "Das Backup-Paket enthält folgende Ordner:",
    warningTextFirmware:
      "Möchten Sie die Ordner und Dateien auf der Maschine im Zielordner überschreiben? Stellen Sie sicher, dass sich die Maschine im Wartungsmodus befindet. Die Firmware-Installation wird nach Ihrer Bestätigung ausgeführt.",
    warningTextBackup:
      "Möchten Sie die Ordner und Dateien auf der Maschine im Zielordner überschreiben? Stellen Sie sicher, dass sich die Maschine im Wartungsmodus befindet. Die Backup-Installation wird nach Ihrer Bestätigung ausgeführt.",
    denyButtonText: "Ablehnen",
    approveButtonText: "Genehmigen",
    denySuccessMessage: "Installationsprozess erfolgreich abgelehnt.",
    denyFailureMessage: "Ablehnen des Installationsprozesses fehlgeschlagen",
    denyErrorMessageFirmware: "Fehler beim Ablehnen der Firmware-Installation",
    denyErrorMessageBackup: "Fehler beim Ablehnen der Backup-Installation",
    approveSuccessMessage: "Installationsprozess erfolgreich genehmigt.",
    approveFailureMessage:
      "Genehmigen des Installationsprozesses fehlgeschlagen",
    approveErrorMessageFirmware:
      "Fehler beim Genehmigen der Firmware-Installation",
    approveErrorMessageBackup: "Fehler beim Genehmigen der Backup-Installation",
  },
};

export const otaConfirmFirmwareInstallationModalZhHans = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "关闭确认固件安装弹窗",
    closeModalAriaLabelBackup: "关闭确认备份安装弹窗",
    titleFirmware: "确认固件安装",
    titleBackup: "确认备份安装",
    firmwareSectionTitle: "该固件",
    backupSectionTitle: "该备份",
    uploadedAtLabel: "上传于",
    machineSectionTitle: "将被推送到设备",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    targetPathLabel: "设备上的目标路径",
    firmwareFoldersSectionTitle: "固件包包含以下文件夹：",
    backupFoldersSectionTitle: "备份包包含以下文件夹：",
    warningTextFirmware:
      "您是否要覆盖目标文件夹中机器上的文件夹和文件？请确保机器处于维护模式。固件安装将在您确认后执行。",
    warningTextBackup:
      "您是否要覆盖目标文件夹中机器上的文件夹和文件？请确保机器处于维护模式。备份安装将在您确认后执行。",
    denyButtonText: "拒绝",
    approveButtonText: "批准",
    denySuccessMessage: "安装流程已成功拒绝。",
    denyFailureMessage: "拒绝安装流程失败",
    denyErrorMessageFirmware: "拒绝固件安装时出错",
    denyErrorMessageBackup: "拒绝备份安装时出错",
    approveSuccessMessage: "安装流程已成功批准。",
    approveFailureMessage: "批准安装流程失败",
    approveErrorMessageFirmware: "批准固件安装时出错",
    approveErrorMessageBackup: "批准备份安装时出错",
  },
};

export const otaConfirmFirmwareInstallationModalIt = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Chiudi la finestra di conferma installazione firmware",
    closeModalAriaLabelBackup:
      "Chiudi la finestra di conferma installazione backup",
    titleFirmware: "Conferma installazione firmware",
    titleBackup: "Conferma installazione backup",
    firmwareSectionTitle: "Il firmware",
    backupSectionTitle: "Il backup",
    uploadedAtLabel: "caricato il",
    machineSectionTitle: "verrà inviato alla macchina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    targetPathLabel: "Percorso di destinazione sulla macchina",
    firmwareFoldersSectionTitle:
      "Il pacchetto firmware contiene le seguenti cartelle:",
    backupFoldersSectionTitle:
      "Il pacchetto backup contiene le seguenti cartelle:",
    warningTextFirmware:
      "Vuoi sovrascrivere le cartelle e i file sulla macchina nella cartella di destinazione? Assicurati che la macchina sia in modalità manutenzione. L'installazione del firmware verrà eseguita dopo la tua conferma.",
    warningTextBackup:
      "Vuoi sovrascrivere le cartelle e i file sulla macchina nella cartella di destinazione? Assicurati che la macchina sia in modalità manutenzione. L'installazione del backup verrà eseguita dopo la tua conferma.",
    denyButtonText: "Nega",
    approveButtonText: "Approva",
    denySuccessMessage: "Processo di installazione negato con successo.",
    denyFailureMessage: "Impossibile negare il processo di installazione",
    denyErrorMessageFirmware:
      "Errore durante il rifiuto dell'installazione del firmware",
    denyErrorMessageBackup:
      "Errore durante il rifiuto dell'installazione del backup",
    approveSuccessMessage: "Processo di installazione approvato con successo.",
    approveFailureMessage: "Impossibile approvare il processo di installazione",
    approveErrorMessageFirmware:
      "Errore durante l'approvazione dell'installazione del firmware",
    approveErrorMessageBackup:
      "Errore durante l'approvazione dell'installazione del backup",
  },
};

export const otaConfirmFirmwareInstallationModalEs = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Cerrar modal de confirmación de instalación de firmware",
    closeModalAriaLabelBackup:
      "Cerrar modal de confirmación de instalación de respaldo",
    titleFirmware: "Confirmar instalación de firmware",
    titleBackup: "Confirmar instalación de respaldo",
    firmwareSectionTitle: "El firmware",
    backupSectionTitle: "El respaldo",
    uploadedAtLabel: "subido el",
    machineSectionTitle: "se enviará a la máquina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    targetPathLabel: "Ruta de destino en la máquina",
    firmwareFoldersSectionTitle:
      "El paquete de firmware contiene las siguientes carpetas:",
    backupFoldersSectionTitle:
      "El paquete de respaldo contiene las siguientes carpetas:",
    warningTextFirmware:
      "¿Desea sobrescribir las carpetas y archivos en la máquina en la carpeta de destino? Asegúrese de que la máquina esté en modo de mantenimiento. La instalación del firmware se ejecutará después de su confirmación.",
    warningTextBackup:
      "¿Desea sobrescribir las carpetas y archivos en la máquina en la carpeta de destino? Asegúrese de que la máquina esté en modo de mantenimiento. La instalación del respaldo se ejecutará después de su confirmación.",
    denyButtonText: "Denegar",
    approveButtonText: "Aprobar",
    denySuccessMessage: "Proceso de instalación denegado correctamente.",
    denyFailureMessage: "No se pudo denegar el proceso de instalación",
    denyErrorMessageFirmware: "Error al denegar la instalación del firmware",
    denyErrorMessageBackup: "Error al denegar la instalación del respaldo",
    approveSuccessMessage: "Proceso de instalación aprobado correctamente.",
    approveFailureMessage: "No se pudo aprobar el proceso de instalación",
    approveErrorMessageFirmware: "Error al aprobar la instalación del firmware",
    approveErrorMessageBackup: "Error al aprobar la instalación del respaldo",
  },
};

export const otaConfirmFirmwareInstallationModalNl = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Bevestigingsvenster voor firmware-installatie sluiten",
    closeModalAriaLabelBackup:
      "Bevestigingsvenster voor back-upinstallatie sluiten",
    titleFirmware: "Firmware-installatie bevestigen",
    titleBackup: "Back-upinstallatie bevestigen",
    firmwareSectionTitle: "De firmware",
    backupSectionTitle: "De back-up",
    uploadedAtLabel: "geupload op",
    machineSectionTitle: "wordt naar de machine gepusht",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    targetPathLabel: "Doelpad op de machine",
    firmwareFoldersSectionTitle: "Het firmwarepakket bevat de volgende mappen:",
    backupFoldersSectionTitle: "Het back-uppakket bevat de volgende mappen:",
    warningTextFirmware:
      "Wilt u de mappen en bestanden op de machine in de doelmap overschrijven? Zorg ervoor dat de machine in onderhoudsmodus staat. De firmware-installatie wordt uitgevoerd na uw bevestiging.",
    warningTextBackup:
      "Wilt u de mappen en bestanden op de machine in de doelmap overschrijven? Zorg ervoor dat de machine in onderhoudsmodus staat. De back-upinstallatie wordt uitgevoerd na uw bevestiging.",
    denyButtonText: "Weigeren",
    approveButtonText: "Goedkeuren",
    denySuccessMessage: "Installatieproces succesvol geweigerd.",
    denyFailureMessage: "Installatieproces weigeren is mislukt",
    denyErrorMessageFirmware:
      "Fout bij het weigeren van de firmware-installatie",
    denyErrorMessageBackup: "Fout bij het weigeren van de back-upinstallatie",
    approveSuccessMessage: "Installatieproces succesvol goedgekeurd.",
    approveFailureMessage: "Installatieproces goedkeuren is mislukt",
    approveErrorMessageFirmware:
      "Fout bij het goedkeuren van de firmware-installatie",
    approveErrorMessageBackup:
      "Fout bij het goedkeuren van de back-upinstallatie",
  },
};

export const otaConfirmFirmwareInstallationModalTr = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Ürün yazılımı kurulumunu onaylama penceresini kapat",
    closeModalAriaLabelBackup:
      "Yedekleme kurulumunu onaylama penceresini kapat",
    titleFirmware: "Firmware Kurulumunu Onaylayın",
    titleBackup: "Yedekleme Kurulumunu Onaylayın",
    firmwareSectionTitle: "Ürün yazılımı",
    backupSectionTitle: "Yedekleme",
    uploadedAtLabel: "yüklendi",
    machineSectionTitle: "makineye itilecek",
    machineIdLabel: "İD",
    machineIpLabel: "IP",
    targetPathLabel: "Makinedeki hedef yol",
    firmwareFoldersSectionTitle:
      "Ürün yazılımı paketi aşağıdaki klasörleri içerir:",
    backupFoldersSectionTitle: "Yedekleme paketi aşağıdaki klasörleri içerir:",
    warningTextFirmware:
      "Hedef klasördeki makinedeki klasörlerin ve dosyaların üzerine yazmak istiyor musunuz? Lütfen makinenin bakım modunda olduğundan emin olun. Firmware kurulumu onayınız sonrasında gerçekleştirilecektir.",
    warningTextBackup:
      "Hedef klasördeki makinedeki klasörlerin ve dosyaların üzerine yazmak istiyor musunuz? Lütfen makinenin bakım modunda olduğundan emin olun. Onayınız sonrasında yedekleme kurulumu gerçekleştirilecektir.",
    denyButtonText: "Reddetmek",
    approveButtonText: "Onaylamak",
    denySuccessMessage: "Yükleme işlemi başarıyla reddedildi.",
    denyFailureMessage: "Yükleme işlemi reddedilemedi",
    denyErrorMessageFirmware:
      "Ürün yazılımı yüklemesi reddedilirken hata oluştu",
    denyErrorMessageBackup: "Yedekleme yüklemesi reddedilirken hata oluştu",
    approveSuccessMessage: "Kurulum işlemi başarıyla onaylandı.",
    approveFailureMessage: "Yükleme işlemi onaylanamadı",
    approveErrorMessageFirmware:
      "Ürün yazılımı yüklemesi onaylanırken hata oluştu",
    approveErrorMessageBackup: "Yedekleme kurulumu onaylanırken hata oluştu",
  },
};
